import { Suspense } from "react";
import { Outlet } from "react-router";
import { Loader } from "@/components/Loader";
import { Header } from "./Header";

export const AccountLayout = () => {
  return (
    <>
      <Header />

      <div className="flex w-full overflow-y-auto">
        <Suspense fallback={<Loader />}>
          <Outlet />
        </Suspense>
      </div>
    </>
  );
};
